<template>
  <div>
    <div class="page-header"><div><h1 class="page-title">{{ t('portal.navProjects') }}</h1></div></div>
    <div v-if="loading" class="spinner"></div>
    <div v-else-if="projects.length === 0" class="empty-state"><p>{{ t('portal.noProjects') }}</p></div>
    <div v-else class="proj-list">
      <router-link v-for="p in projects" :key="p.id" :to="'/portal/projects/' + p.id" class="proj-card">
        <span class="proj-dot" :style="{ background: p.color }"></span>
        <div class="proj-body">
          <div class="proj-name">{{ p.name }}</div>
          <div class="proj-meta">{{ p.task_count }} {{ t('portal.openTasks') }} · {{ fmtMoney(projectTotal(p), p.currency) }}</div>
        </div>
        <span class="proj-go">→</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import api from '@/api'
import { useI18n } from '@/composables/useI18n'
import { fmtMoney, projectTotal } from '@/utils/billing'

export default {
  name: 'ClientProjects',
  setup() {
    const { t } = useI18n()
    const projects = ref([])
    const loading = ref(true)
    onMounted(async () => {
      try { projects.value = (await api.getProjects()).data || [] } catch {} finally { loading.value = false }
    })
    return { t, projects, loading, fmtMoney, projectTotal }
  },
}
</script>

<style scoped>
.page-sub { color: var(--muted); font-size: 13px; }
.proj-list { display: flex; flex-direction: column; gap: 10px; }
.proj-card {
  display: flex; align-items: center; gap: 12px;
  background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius);
  padding: 16px; text-decoration: none; color: var(--text); transition: border-color .12s, background .12s;
}
.proj-card:hover { border-color: var(--accent); background: var(--accent-wash); }
.proj-dot { width: 12px; height: 12px; border-radius: 4px; flex-shrink: 0; }
.proj-body { flex: 1; min-width: 0; }
.proj-name { font-size: 15px; font-weight: 600; }
.proj-meta { font-size: 12px; color: var(--muted); margin-top: 2px; }
.proj-go { color: var(--muted); }
</style>
